import React from 'react';

import * as ManifestUI from '@project44/manifest-ds';

import { TFunctionComponent } from '../../../../../shared/core/infrastructrue/types';
import { TUserTenantAgnosticRolesCheckbox } from '../../../domain/interfaces';

export const UserTenantAgnosticRolesCheckbox: TFunctionComponent<TUserTenantAgnosticRolesCheckbox> =
  ({
    isApiRequestInProgress,
    handleAddRole,
    handleRemoveRole,
    isEditableByUserPrincipal,
    unifiedRole,
    assignedUserTenantAgnosticRolesState,
  }) => {
    const [
      assignedUserTenantAgnosticRoles,
      updateAssignedUserTenantAgnosticRoles,
    ] = assignedUserTenantAgnosticRolesState;

    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <ManifestUI.Checkbox
          role={'checkbox'}
          aria-label={`role ${unifiedRole.name}`}
          onChange={(isSelected) => {
            const handleUpdateUnifiedRole = isSelected
              ? handleAddRole
              : handleRemoveRole;
            updateAssignedUserTenantAgnosticRoles(
              handleUpdateUnifiedRole(
                assignedUserTenantAgnosticRoles,
                unifiedRole.id,
              ),
            );
          }}
          isDisabled={
            !isEditableByUserPrincipal ||
            isApiRequestInProgress ||
            !assignedUserTenantAgnosticRoles.has(unifiedRole.id)
          }
          name={unifiedRole.name}
          isSelected={!!assignedUserTenantAgnosticRoles.get(unifiedRole.id)}
        >
          <ManifestUI.VisuallyHidden>
            {unifiedRole.name}
          </ManifestUI.VisuallyHidden>
        </ManifestUI.Checkbox>
      </div>
    );
  };
